/**
 * Shared form steps configuration used by both Questionnaire and Editor pages
 */

import { IntroductionStep } from '../../questionnaire/steps/IntroductionStep';
import { BasicInfoStep } from '../../questionnaire/steps/BasicInfoStep';
import { ColorPickerStep } from '../../questionnaire/steps/ColorPickerStep';
import { DesktopImageStep } from '../../questionnaire/steps/DesktopImageStep';
import { MobileImageStep } from '../../questionnaire/steps/MobileImageStep';
import { CeremonyLocationStep } from '../../questionnaire/steps/CeremonyLocationStep';
import { WeddingLocationStep } from '../../questionnaire/steps/WeddingLocationStep';
import { GuestsFAQStep } from '../../questionnaire/steps/GuestsFAQStep';
import { WitnessesStep } from '../../questionnaire/steps/WitnessesStep';
import { MenuStep } from '../../questionnaire/steps/MenuStep';
import { ScheduleStep } from '../../questionnaire/steps/ScheduleStep';
import { ContactStep } from '../../questionnaire/steps/ContactStep';
import { DomainSelectionStep } from '../../questionnaire/steps/DomainSelectionStep';
import { FinalConfirmationStep } from '../../questionnaire/steps/FinalConfirmationStep';
import { TablesEditorStep } from '../../questionnaire/steps/TablesEditorStep';

export interface FormStep {
    id: string;
    title: string;
    component: React.ComponentType<any>;
    isIntro?: boolean;
}

export const formSteps: FormStep[] = [
    {
        id: 'introduction',
        title: 'Welcome',
        component: IntroductionStep,
        isIntro: true
    },
    {
        id: 'basic-info',
        title: 'Basic Information',
        component: BasicInfoStep
    },
    {
        id: 'colors',
        title: 'Colors',
        component: ColorPickerStep
    },
    {
        id: 'desktop-image',
        title: 'Desktop Image',
        component: DesktopImageStep
    },
    {
        id: 'mobile-image',
        title: 'Mobile Image',
        component: MobileImageStep
    },
    {
        id: 'ceremony-location',
        title: 'Ceremony Location',
        component: CeremonyLocationStep
    },
    {
        id: 'wedding-location',
        title: 'Wedding Location',
        component: WeddingLocationStep
    },
    {
        id: 'guests-faq',
        title: 'Guests FAQ',
        component: GuestsFAQStep
    },
    {
        id: 'witnesses',
        title: 'Witnesses',
        component: WitnessesStep
    },
    {
        id: 'menu',
        title: 'Menu',
        component: MenuStep
    },
    {
        id: 'schedule',
        title: 'Schedule',
        component: ScheduleStep
    },
    {
        id: 'contact',
        title: 'Contact',
        component: ContactStep
    },
    {
        id: 'domain',
        title: 'Domain',
        component: DomainSelectionStep
    },
    {
        id: 'confirmation',
        title: 'Confirmation',
        component: FinalConfirmationStep
    }
];

const editorOnlySteps: FormStep[] = [
    {
        id: 'tables',
        title: 'Tables',
        component: TablesEditorStep
    }
];

/**
 * Get steps suitable for editing mode (excludes intro, domain, and confirmation)
 */
export const getEditorSteps = (): FormStep[] => {
    return [
        ...formSteps.filter(step => !step.isIntro && step.id !== 'confirmation' && step.id !== 'domain'),
        ...editorOnlySteps
    ];
};
